export default {
    nav: {
        home: 'Startseite',
        services: 'Dienstleistungen',
        about: 'Über uns',
        achievements: 'Portfolio',
        gallery: 'Galerie',
        contact: 'Kontakt'
    },
    hero: {
        title: 'IT Support Dienstleister Deutschlandweit, Individuell angepasste IT-Services & Beste Lösungen',
        subtitle: 'Wir helfen Ihnen, Ihre Geschäftsprozesse und Arbeitsabläufe mit innovativen Technologien zu transformieren und zu optimieren. Wir liefern die besten IT-Lösungen einschließlich IT Service Management (ITSM), IT-Infrastruktur und 24/7 IT-Support.',
        sliderText: 'Wir glauben dass Teamwork, Verantwortung und gegenseitiger Respekt wesentlich sind, um hochwertige Dienstleistungen und Lösungen zu bieten.',
        cta: 'Jetzt starten'
    },
    
    services: {
        title: 'Unsere häufig gefragten Dienstleistungen, natürlich können wir mehr',
        subtitle: 'Umfassende IT-Services von Ihrem erfahrenen IT Dienstleister',
        description: 'Als erfahrener IT Dienstleister in Heidelberg liefert Heidelbell die besten IT-Lösungen und Services. Stärkung Ihres Unternehmens mit modernsten Technologielösungen und Experten-Support. Unsere bewährte 3Es-Methodik gewährleistet erfolgreiche Projektabwicklung. Wir bieten On-Demand-Dispatch und IT-Infrastruktur-Support in ganz Deutschland und den benachbarten europäischen Ländern und nutzen dabei unser Netzwerk von kompetenten Smart-Hands und Ingenieuren.',
        hero: {
            titlePart1: 'Wir bieten nicht nur IT-Support Dienstleistungen,',
            titlePart2: 'wir glauben an die Kraft der Technologie, Unternehmen zu transformieren.',
            subtitle: 'Von Smart-Hands bis zu Experten, wir sind hier, um Ihre Arbeit richtig zu erledigen.'
        },
        landingCTA: {
            title: 'Bereit, Ihr Unternehmen zu transformieren?',
            description: 'Lassen Sie uns besprechen, wie unsere IT-Lösungen Ihren Erfolg mit unserer bewährten 3Es-Methodik vorantreiben können.',
            buttonConsultation: 'Kostenlose Beratung erhalten',
            buttonPortfolio: 'Unser Portfolio ansehen'
        },
        overview: {
            label: 'Unsere Expertise',
            title: 'Umfassende IT-Dienstleistungen',
            description: 'Wir bieten maßgeschneiderte IT-Lösungen für Unternehmen jeder Größe. Unsere Experten unterstützen Sie bei der digitalen Transformation.'
        },
        servicesList: {
            cloud: {
                title: 'Cloud-Lösungen',
                description: 'Moderne Cloud-Infrastruktur und -Dienste für skalierbare und sichere Geschäftsanwendungen.',
                features: [
                    'Cloud-Migration & Strategie',
                    'Infrastructure as a Service',
                    'Cloud-Sicherheit & Compliance',
                    '24/7 Cloud-Monitoring'
                ],
                benefits: [
                    'Kosteneinsparungen durch optimierte Ressourcennutzung',
                    'Höhere Flexibilität und Skalierbarkeit',
                    'Verbesserte Sicherheit und Compliance',
                    'Schnellere Time-to-Market für neue Anwendungen'
                ]
            },
            resourceTeams: {
                title: 'Ressourcen oder Teams als Service',
                description: 'Zugriff auf qualifizierte IT-Fachkräfte und dedizierte Teams nach Bedarf, um Ihre Projekte und Betrieb zu skalieren.',
                features: [
                    'Dedizierte Team-Services',
                    'Personalaufstockung',
                    'Experten-Ressourcenzuteilung',
                    'Flexible Team-Skalierung'
                ],
                benefits: [
                    'Zugriff auf spezialisierte IT-Expertise bei Bedarf',
                    'Skalierbare Teamressourcen für Projektanforderungen',
                    'Kosteneffiziente Lösung für temporäre oder laufende Bedürfnisse',
                    'Reduzierte Einstellungs- und Schulungskosten'
                ]
            },
            itSupport: {
                title: 'IT-Support',
                description: 'Experten für technischen Support und Wartung Ihrer IT-Infrastruktur.',
                features: [
                    '24/7 Technischer Support',
                    'Systemwartung',
                    'Hardware- & Software-Support',
                    'Fernassistenz'
                ],
                benefits: [
                    'Minimierte Ausfallzeiten',
                    'Schnelle Problemlösung',
                    'Proaktive Systemwartung',
                    'Kosteneffiziente IT-Betreuung'
                ]
            },
            optimization: {
                title: 'Prozessoptimierung',
                description: 'Steigern Sie Ihre Betriebsabläufe mit unserem systematischen Ansatz zur Prozessoptimierung. Wir identifizieren Engpässe, implementieren RPA-Automatisierung und nutzen datengestützte Erkenntnisse für messbare Verbesserungen in Effizienz und Kosteneinsparungen.',
                features: [
                    'Prozessanalyse & -mapping',
                    'Effizienzsteigerung',
                    'Workflow-Automatisierung',
                    'Leistungsüberwachung'
                ],
                benefits: [
                    'Erhöhte operative Effizienz',
                    'Erhebliche Kosteneinsparungen durch Optimierung',
                    'Automatisierte Workflows reduzieren manuelle Arbeit',
                    'Datengestützte Erkenntnisse für kontinuierliche Verbesserung'
                ]
            }
        },
        whyChooseUs: {
            label: 'Warum wir?',
            title: 'Ihr vertrauenswürdiger IT-Partner',
            expertise: {
                title: 'Bewährte Expertise',
                description: '10+ Jahre IT-Erfahrung mit erfolgreichen Projekten in verschiedenen Branchen und ITIL-zertifiziertem Team.'
            },
            solutions: {
                title: 'Innovative Lösungen',
                description: 'Moderne Technologien und bewährte Methoden für maßgeschneiderte IT-Lösungen, die Ihr Unternehmen voranbringen.'
            },
            support: {
                title: 'Zuverlässiger Support',
                description: '24/7 technischer Support mit schnellen Reaktionszeiten und proaktiver Wartung für maximale Verfügbarkeit.'
            }
        },
        modal: {
            mainFeatures: 'Hauptfunktionen',
            benefits: 'Vorteile',
            contactUs: 'Kontaktieren Sie uns',
            learnMore: 'Mehr erfahren'
        },
        cta: {
            title: 'Bereit für die digitale Transformation?',
            description: 'Kontaktieren Sie uns für eine kostenlose Beratung und entdecken Sie, wie wir Ihr Unternehmen unterstützen können.',
            button: 'Jetzt kontaktieren'
        },
        serviceModels: {
            title: 'Sonderangebot für unsere Stadt',
            subtitle: 'Wählen Sie das IT-Wartungs-Support-Modell, das zu den Bedürfnissen Ihres Unternehmens passt',
            flatRate: {
                title: 'Pauschaler Basis-Gesundheitscheck-Service',
                timeFrame: 'Zwei Stunden pro Monat',
                description: 'Unser Basis-Gesundheitscheck-Plan bietet proaktive monatliche Wartung, um Ihre wesentlichen IT-Systeme reibungslos am Laufen zu halten. Dieser Service umfasst:',
                features: [
                    'Wartung und Support für 2 Arbeitsplatz-/Schreibtisch-Setups',
                    'Betriebssystem-Diagnose und Problemlösung',
                    'Software- und Treiberstatusprüfungen und Updates',
                    'Netzwerkkonnektivitäts- und Leistungsprüfung',
                    'Sicherheitsbewertung zur Identifizierung potenzieller Bedrohungen'
                ],
                conclusion: 'Dieser Plan stellt sicher, dass Ihre Kern-Geräte sicher, aktualisiert und optimal funktionieren—alles zu vorhersehbaren monatlichen Kosten.',
                contactForPrice: 'Für Preis kontaktieren Sie uns'
            },
            activityBased: {
                title: 'Aktivitätsbasierter maßgeschneiderter Service',
                description: 'Dieses Modell gibt Ihnen vollständige Kontrolle über Ihren IT-Support. Wir passen den Service basierend auf Ihren erforderlichen Aktivitäten an, wie z. B.:',
                activities: [
                    'Geräteeinrichtung und Fehlerbehebung',
                    'Betriebssystem-, Software- und Treiber-Updates',
                    'Netzwerkdiagnose und -optimierung',
                    'Sicherheitsüberprüfung und Bedrohungsbereinigung',
                    'Backup- oder Cloud-Konfiguration',
                    'Benutzerkontoeinrichtung oder Berechtigungsänderungen'
                ],
                conclusion: 'Jede Aufgabe wird einzeln abgerechnet oder in einen maßgeschneiderten Plan gruppiert—ideal für Unternehmen mit sich ändernden IT-Bedürfnissen.',
                contactForPrice: 'Für Preis kontaktieren Sie uns'
            }
        },
        items: {
            infrastructure: {
                title: 'On-Demand Infrastruktur Dienste & Wartung',
                description: 'Unsere umfassenden Hardware-, Netzwerk- und Rechenzentrums-Wartungsdienste helfen Ihnen, das volle Potenzial Ihrer IT-Infrastruktur mit zuverlässigen, skalierbaren Lösungen freizusetzen.',
                features: [
                    'Hardware-Installation & Einrichtung',
                    'Netzwerkinfrastruktur-Management',
                    'Rechenzentrums-Betrieb',
                    'Systemleistungsoptimierung'
                ],
                benefits: [
                    'Reduzierte Ausfallzeiten durch proaktive Wartung',
                    'Skalierbare Infrastruktur, die mit Ihrem Unternehmen wächst',
                    'Experten-Management komplexer IT-Umgebungen',
                    'Kosteneffiziente Lösungen für Infrastrukturbedürfnisse'
                ]
            },
            /*
            helpdesk: {
                title: '24/7 Help Desk Support',
                description: 'Unser ITIL-zertifizierter Helpdesk bietet rund um die Uhr Incident Management und Problemlösung. Wir priorisieren schnelle Lösungszeiten und halten uns an strenge SLAs, um sicherzustellen, dass Ihre Probleme effizient gelöst werden.',
                features: [
                    '24/7 Technischer Support',
                    'Fernassistenz',
                    'Schnelle Problemlösung',
                    'Benutzerschulung & Dokumentation'
                ],
                
                benefits: [
                    'Minimierte Ausfallzeiten mit schnellen Reaktionszeiten',
                    'ITIL-zertifizierte Prozesse für konsistenten Service',
                    'Umfassende Benutzerunterstützung und Schulung',
                    'Rund um die Uhr Verfügbarkeit für kritische Probleme'
                ]
            },
            */
            project: {
                title: 'Projektmanagement Support',
                description: 'Von der Planung bis zur Ausführung liefern unsere erfahrenen Projektmanager Ergebnisse pünktlich, im Rahmen und über den Erwartungen. Wir stellen sicher, dass jedes Projekt eine Erfolgsgeschichte wird.',
                features: [
                    'Strategische Projektplanung',
                    'Software-Installation & Konfiguration',
                    'Change Management',
                    'Qualitätssicherung & Testing'
                ],
                benefits: [
                    'Pünktliche Projektdurchführung im Budget',
                    'Experten-Projektmanagement und Koordination',
                    'Reduzierte Projektrisiken und verbesserte Ergebnisse',
                    'Nahtlose Implementierung mit minimaler Störung'
                ]
            },
            /*
            development: {
                title: 'Applikation-Entwicklung & Testing',
                description: 'Unsere umfassenden Software-Entwicklungs- und Systemqualitätstest-Dienste stellen robuste, zuverlässige und optimierte Lösungen sicher, die höchsten Qualitätsstandards entsprechen.',
                features: [
                    'Maßgeschneiderte Softwareentwicklung',
                    'Code-Review & Optimierung',
                    'Umfassendes Testing',
                    'Technische Dokumentation'
                ],
                benefits: [
                    'Hochwertiger, wartbarer Code',
                    'Reduzierte Fehler und verbesserte Zuverlässigkeit',
                    'Umfassendes Testing für robuste Lösungen',
                    'Gut dokumentierter Code für zukünftige Wartung'
                ]
            },
            */
            optimization: {
                title: 'Prozessoptimierung',
                description: 'Steigern Sie Ihre Betriebsabläufe mit unserem systematischen Ansatz zur Prozessoptimierung. Wir identifizieren Engpässe, implementieren RPA-Automatisierung und nutzen datengestützte Erkenntnisse für messbare Verbesserungen in Effizienz und Kosteneinsparungen.',
                features: [
                    'Prozessanalyse & -mapping',
                    'Effizienzsteigerung',
                    'Workflow-Automatisierung',
                    'Leistungsüberwachung'
                ],
                benefits: [
                    'Erhöhte operative Effizienz',
                    'Erhebliche Kosteneinsparungen durch Optimierung',
                    'Automatisierte Workflows reduzieren manuelle Arbeit',
                    'Datengestützte Erkenntnisse für kontinuierliche Verbesserung'
                ]
            },
            data: {
                title: 'Datenmanagement und Analytik',
                description: 'Wir sind Experten für die Speicherung, Analyse und Verwaltung von Big Data. Unsere Lösungen helfen Ihnen, fortschrittliche Analysen für umsetzbare Erkenntnisse und fundierte Entscheidungsfindung zu nutzen.',
                features: [
                    'Big Data Management',
                    'Erweiterte Analytik',
                    'Sichere Speicherlösungen',
                    'Daten-Governance & Compliance'
                ],
                benefits: [
                    'Umsetzbare Erkenntnisse aus Ihren Daten',
                    'Sicheres und konformes Datenmanagement',
                    'Verbesserte Entscheidungsfindung mit Analytik',
                    'Skalierbare Datenlösungen für wachsende Bedürfnisse'
                ]
            },
            dispatch: {
                title: 'Resource or Team as Service',
                description: 'Professioneller Level 1 & 2 IT-Support mit zertifizierten Ingenieuren. Unser mehrsprachiges Team bietet schnelle Reaktionszeiten, technische Fehlerbehebung und maßgeschneiderte Lösungen für nahtlose IT-Betriebe.',
                features: [
                    'Level 1 & 2 Technischer Support',
                    'Mehrsprachiges Serviceteam',
                    'Schnelle Reaktionszeiten',
                    'Zertifizierte IT-Ingenieure'
                ],
                benefits: [
                    'Experten-Technischer Support, wenn Sie ihn brauchen',
                    'Mehrsprachiges Team für globale Operationen',
                    'Schnelle Reaktionszeiten für kritische Probleme',
                    'Zertifizierte Fachkräfte für qualitativ hochwertigen Service'
                ]
            },
            itsm: {
                title: 'ITSM (IT-Service-Management)',
                description: 'Umfassende IT-Service-Management-Lösungen zur Optimierung Ihrer IT-Betriebe, Verbesserung der Servicebereitstellung und Ausrichtung der IT-Services auf Geschäftsziele. Wir implementieren branchenübliche Best Practices einschließlich ITIL-Frameworks.',
                features: [
                    'ITIL-Framework-Implementierung',
                    'Service Desk & Incident Management',
                    'Change & Configuration Management',
                    'Service Level Agreement (SLA) Management'
                ],
                benefits: [
                    'Verbesserte IT-Servicequalität und Konsistenz',
                    'Bessere Ausrichtung zwischen IT und Geschäftszielen',
                    'Reduzierte Serviceunterbrechungen und schnellere Lösung',
                    'Erhöhte Transparenz und Kontrolle über IT-Services'
                ]
            },
            itad: {
                title: 'ITAD (IT-Asset-Disposition)',
                description: 'Sichere und umweltverantwortliche IT-Asset-Disposition-Services. Wir helfen Ihnen bei der ordnungsgemäßen Außerbetriebnahme, dem Recycling und der Entsorgung von IT-Geräten unter Gewährleistung der Datensicherheit und Einhaltung der Umweltvorschriften.',
                features: [
                    'Sichere Datenvernichtung & -löschung',
                    'IT-Asset-Außerbetriebnahme & -Entsorgung',
                    'Umweltkonformität & Recycling',
                    'Asset-Tracking & Dokumentation'
                ],
                benefits: [
                    'Sichere Datenvernichtung zum Schutz sensibler Informationen',
                    'Einhaltung der Umweltvorschriften',
                    'Ordnungsgemäßes Asset-Lifecycle-Management',
                    'Kostenrückgewinnung durch Asset-Wiederverkaufsprogramme'
                ]
            },
            itam: {
                title: 'ITAM (IT-Asset-Management)',
                description: 'Umfassende IT-Asset-Management-Lösungen zur Nachverfolgung, Verwaltung und Optimierung Ihrer IT-Assets während ihres gesamten Lebenszyklus. Wir helfen Ihnen, genaue Asset-Inventare zu führen, Compliance sicherzustellen und den Wert Ihrer IT-Investitionen zu maximieren.',
                features: [
                    'Asset-Erkennung & Inventarverwaltung',
                    'Lebenszyklus-Tracking & Wartung',
                    'Lizenz- & Compliance-Management',
                    'Kostenoptimierung & Reporting'
                ],
                benefits: [
                    'Vollständige Transparenz in Ihr IT-Asset-Portfolio',
                    'Reduzierte Kosten durch optimierte Asset-Nutzung',
                    'Compliance mit Software-Lizenzanforderungen',
                    'Datenbasierte Entscheidungen für IT-Investitionen'
                ]
            }
        }
    },
    about: {
        title: 'Über uns',
        subtitle: 'Ihr zuverlässiger Technologiepartner',
        hero: {
            titlePart1: 'Über',
            titlePart2: 'Heidelbell',
            subtitle: 'Ihr vertrauenswürdiger IT-Partner für innovative Lösungen'
        },
        description: 'Heidelbell ist ein dynamisches, technologiegetriebenes Beratungs- und Dienstleistungsunternehmen mit Sitz in Heidelberg, Deutschland. Wir sind darauf spezialisiert, Organisationen dabei zu helfen, betriebliche Exzellenz durch unsere bewährte 3Es-Methode zu erreichen: Evaluate, Execute und Elevate. Unser ITIL-zertifiziertes Team bietet umfassende IT-Unterstützung, Prozessoptimierung und digitale Transformationsdienste.',
        companyStory: {
            label: 'Unsere Geschichte',
            title: 'Von Heidelberg in die Welt',
            paragraph1: 'Seit 2022 sind wir Ihr vertrauenswürdiger Partner für digitale Transformation. Unsere Mission: Unternehmen mit innovativen IT-Lösungen zu nachhaltigem Erfolg zu verhelfen.',
            paragraph2: 'Mit unserem ITIL-zertifizierten Team bieten wir maßgeschneiderte Lösungen für Unternehmen jeder Größe. Unser Fokus: Zuverlässigkeit, Innovation und messbare Ergebnisse.'
        },
        milestones: [
            {
                year: '2022',
                description: 'Gründung von Heidelbell in Heidelberg mit Fokus auf IT-Support und Beratung'
            },
            {
                year: '2023',
                description: 'Erweiterung des Serviceportfolios um Cloud-Lösungen und Cybersicherheit'
            },
            {
                year: '2024',
                description: 'Eröffnung neuer Standorte und Ausbau des Teams'
            }
        ],
        values: {
            label: 'Unsere Werte',
            title: 'Was uns antreibt',
            items: [
                {
                    title: 'Innovation',
                    description: 'Moderne Technologien und zukunftsorientierte Lösungen für nachhaltigen Erfolg.'
                },
                {
                    title: 'Zuverlässigkeit',
                    description: '24/7 Support mit schnellen Reaktionszeiten und proaktiver Wartung.'
                },
                {
                    title: 'Partnerschaft',
                    description: 'Langfristige Zusammenarbeit mit messbaren Ergebnissen und kontinuierlicher Verbesserung.'
                }
            ]
        },
        team: {
            label: 'Unser Team',
            title: 'Die Experten hinter Heidelbell',
            members: [
                {
                    name: 'Dr. Naved Chaudhri',
                    position: 'Geschäftsführer',
                    bio: '15+ Jahre Erfahrung in IT und Medizintechnologien, Spezialist für digitale Transformation und strategische IT-Beratung.',
                    linkedin: 'https://www.linkedin.com/in/naved-c-a2a920b6'
                }
            ],
            poolImage: {
                title: 'Unser Techniker-Netzwerk',
                description: 'Ein Netzwerk aus Ingenieuren und Technikern in ganz Deutschland, bereit, Ihr Unternehmen zu unterstützen, wo immer Sie sind.'
            }
        },
        cta: {
            title: 'Bereit für die Zusammenarbeit?',
            description: 'Lassen Sie uns gemeinsam Ihre IT-Herausforderungen lösen und Ihr Unternehmen digital transformieren.',
            button: 'Kontakt aufnehmen'
        },
        method: {
            title: 'Unsere bewährte 3Es-Methode',
            evaluate: 'Bewerten Sie Ihre aktuelle Situation und identifizieren Sie Verbesserungsmöglichkeiten',
            execute: 'Führen Sie strategische Pläne mit Präzision und Expertise aus',
            elevate: 'Erheben Sie Ihr Unternehmen auf neue Höhen des Erfolgs und der Effizienz'
        },
        stats: {
            experience: 'Jahre Erfahrung',
            clients: 'Zufriedene Kunden',
            projects: 'Abgeschlossene Projekte',
            support: '24/7 Support'
        },
        achievement: {
            number: '10+',
            label: 'Jahre Expertise'
        },
        whyChooseTitle: 'Warum Heidelbell wählen',
        whyChoosePoints: [
            'ITIL-zertifiziertes Team mit bewährten Branchenpraktiken',
            'Mehrsprachiger Support mit kulturellem Verständnis',
            'Bewährte 3Es-Methodik für garantierte Ergebnisse',
            'Umfassende End-to-End IT-Lösungen',
            '24/7 Support mit schnellen Reaktionszeiten',
            'Maßgeschneiderte Lösungen für Ihr Unternehmen'
        ]
    },

    gallery: {
        title: 'Unsere Arbeit',
        subtitle: 'Projektgalerie',
        hero: {
            title: 'Unsere Arbeit',
            subtitle: 'Projektgalerie'
        },
        viewDetails: 'Details anzeigen'
    },
    portfolio: {
        comingSoon: {
            title: 'Demnächst verfügbar',
            message: 'Unser Portfolio wird derzeit erstellt. Schauen Sie bald wieder vorbei, um unsere großartigen Projekte und Fallstudien zu sehen!',
            close: 'Schließen'
        }
    },
    brands: {
        label: 'Unsere Partner',
        title: 'Vertrauenswürdige IT-Marken, mit denen wir arbeiten',
        description: 'Unsere Experten kennen mit führenden Technologieanbietern aus, um die besten Lösungen für Ihr Unternehmen zu liefern',
        items: [
            { name: 'Microsoft', icon: 'MS' },
            { name: 'AWS', icon: 'AWS' },
            { name: 'Cisco', icon: 'CS' },
            { name: 'VMware', icon: 'VM' },
            { name: 'Oracle', icon: 'OR' },
            { name: 'IBM', icon: 'IBM' },
            { name: 'Dell', icon: 'DL' },
            { name: 'HP', icon: 'HP' },
            { name: 'Red Hat', icon: 'RH' },
            { name: 'SAP', icon: 'SAP' },
            { name: 'Salesforce', icon: 'SF' },
            { name: 'Google Cloud', icon: 'GC' }
        ]
    },
    contact: {
        //title: 'Bereit, Ihr Unternehmen zu transformieren?',
        title: 'Die Lösung liegt im fokussierten Zuhören, und das können wir.',
        subtitle: 'Lassen Sie uns besprechen, wie wir Ihnen helfen können, betriebliche Exzellenz zu erreichen',
        hero: {
            titlePart1: 'Fokussiertes Zuhören.',
            titlePart2: 'Bessere Lösungen',
            subtitle: 'Durch konzentriertes Zuhören verwandeln wir Ihre Anliegen in Lösungen.'
        },
        form: {
            title: 'Senden Sie uns eine Nachricht',
            firstName: 'Vorname',
            lastName: 'Nachname',
            name: 'Name',
            email: 'E-Mail',
            phone: 'Telefon',
            service: 'Dienstleistungstyp',
            serviceType: 'Welche Art von Dienstleistungen',
            selectService: 'Wählen Sie einen Service',
            subject: 'Betreff',
            message: 'Nachricht',
            submit: 'Nachricht senden',
            submitting: 'Wird gesendet...',
            success: 'Ihre Nachricht wurde erfolgreich gesendet. Wir werden uns in Kürze bei Ihnen melden.'
        },
        validation: {
            nameRequired: 'Name ist erforderlich.',
            emailRequired: 'E-Mail ist erforderlich.',
            emailInvalid: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
            subjectRequired: 'Betreff ist erforderlich.',
            messageRequired: 'Nachricht ist erforderlich.'
        },
        info: {
            title: 'Kontaktinformationen',
            description: 'Unser Team steht Ihnen für alle Fragen zur Verfügung. Wir antworten innerhalb von 24 Stunden.',
            address: {
                label: 'Adresse',
                value: 'Jahnstrasse 32, 69120 Heidelberg, Deutschland'
            },
            officeAddress: {
                label: 'Büroadresse',
                value: 'Ringstr. 19B, 69115 Heidelberg, Deutschland'
            },
            phone: {
                label: 'Telefon',
                value: '+49 (0) 6221 6470309'
            },
            email: {
                label: 'E-Mail',
                value: 'connect@heidelbell.com'
            },
            location: {
                label: 'Standort',
                value: 'Heidelberg, Deutschland'
            },
            whatsapp: {
                label: 'WhatsApp',
                value: '+49 176 47050093'
            },
            addressValue: 'Ringstr. 19B, 69115 Heidelberg, Deutschland',
            emailValue: 'connect@heidelbell.com',
            phoneValue: '+49 (0) 6221 6470309',
            whatsappValue: '+49 176 47050093'
        },
        businessHours: {
            title: 'Öffnungszeiten',
            days: [
                { name: 'Montag - Freitag', hours: '09:00 - 18:00' },
                { name: 'Samstag', hours: 'Geschlossen' },
                { name: 'Sonntag', hours: 'Geschlossen' }
            ]
        },
        whyChoose: {
            title: 'Warum uns wählen',
            points: {
                support: '24/7 Support',
                secure: 'Sichere Lösungen',
                fast: 'Schnelle Reaktion',
                method: 'Bewährte 3Es-Methode'
            }
        }
    },
    footer: {
        copyright: '© 2025 Heidelbell',
        links: {
            privacy: 'Datenschutz',
            terms: 'AGB',
            imprint: 'Impressum',
            attributions: 'Bildnachweise'
        },
        bottom: 'All rights reserved by Heidelbell GmbH , Made with ❤️ by Heidelbell'
    },
    // SEO
    seo: {
        home: {
            title: 'IT-Dienstleistungen Heidelberg - Heidelbell | IT-Infrastruktur & Technologie-Beratung',
            description: 'IT-Dienstleistungen Heidelberg - Heidelbell ist ein dynamisches technologiegetriebenes Beratungsunternehmen in Heidelberg, Deutschland. Wir setzen das Potenzial Ihrer Organisation mit unserer bewährten 3Es-Methode frei: Evaluate, Execute, Elevate.',
            keywords: 'IT-Dienstleistungen Heidelberg, IT Dienstleistungen Heidelberg, IT-Services Heidelberg, Heidelberg IT-Dienstleistungen, ITSM, IT-Service-Management, ITAD, IT-Asset-Disposition, ITAM, IT-Asset-Management, Smart Hands, IT-Support, IT-Infrastruktur, Technologie-Beratung, Heidelberg, Deutschland, 3Es-Methode, Software-Entwicklung, Prozessoptimierung, Datenmanagement, ITIL, IT-Operations, IT-Service-Delivery, Remote Hands, Vor-Ort-Support, IT-Beratung, Cloud-Lösungen, Infrastruktur-Services, Netzwerk-Support, Server-Management, Rechenzentrum-Services, Help Desk, Technischer Support, IT-Wartung'
        },
        about: {
            title: 'Über uns - Heidelbell | Technologie-Beratung & 3Es-Methode',
            description: 'Erfahren Sie mehr über Heidelbells bewährte 3Es-Methode (Evaluate, Execute, Elevate) und wie wir Organisationen dabei helfen, ihr Potenzial durch Technologie-Beratung freizusetzen.',
            keywords: 'Über Heidelbell, 3Es-Methode, Technologie-Beratung, Heidelberg, Deutschland, IT-Dienstleistungen, Geschäftstransformation'
        },
        services: {
            title: 'IT-Dienstleistungen - Heidelbell | Infrastruktur, Entwicklung & Support',
            description: 'Umfassende IT-Dienstleistungen einschließlich Infrastruktur-Installation, Help Desk Support, Software-Entwicklung, Prozessoptimierung und Datenmanagement.',
            keywords: 'ITSM, IT-Service-Management, ITAD, IT-Asset-Disposition, ITAM, IT-Asset-Management, Smart Hands, IT-Dienstleistungen, Infrastruktur-Installation, Help Desk Support, Software-Entwicklung, Prozessoptimierung, Datenmanagement, IT-Beratung, ITIL, Remote Hands, Vor-Ort-Support, IT-Operations, IT-Service-Delivery, Technischer Support, IT-Wartung, Cloud-Lösungen, Netzwerk-Support, Server-Management'
        },
        contact: {
            title: 'Kontakt - Heidelbell | Nehmen Sie Kontakt für IT-Lösungen auf',
            description: 'Kontaktieren Sie Heidelbell für IT-Infrastruktur- und Technologie-Beratungsdienstleistungen. Standort in Heidelberg, Deutschland. Erhalten Sie Expertenberatung und Support.',
            keywords: 'Kontakt Heidelbell, IT-Beratung Heidelberg, Technologie-Support, IT-Infrastruktur-Dienstleistungen, Heidelberg IT-Unternehmen, ITSM-Services, ITAD-Services, ITAM-Services, Smart Hands Support'
        }
    },
    // Privacy Policy
    privacy: {
        title: 'Datenschutzerklärung',
        subtitle: 'Datenschutz und Datenschutzinformationen',
        lastUpdated: 'Zuletzt aktualisiert',
        seo: {
            title: 'Datenschutzerklärung - Heidelbell | Datenschutz',
            description: 'Erfahren Sie, wie Heidelbell Ihre persönlichen Daten und Privatsphäre gemäß der DSGVO schützt.'
        },
        introduction: {
            title: 'Einleitung',
            content: 'Heidelbell ist verpflichtet, Ihre Privatsphäre zu schützen und die Sicherheit Ihrer persönlichen Daten zu gewährleisten. Diese Datenschutzerklärung erklärt, wie wir Ihre Informationen sammeln, verwenden und schützen, wenn Sie unsere Website besuchen oder unsere Dienstleistungen nutzen.',
            contact: 'Wenn Sie Fragen zu dieser Datenschutzerklärung haben, kontaktieren Sie uns bitte über die unten angegebenen Informationen.'
        },
        controller: {
            title: 'Verantwortlicher',
            name: 'Firmenname',
            address: 'Adresse',
            email: 'E-Mail',
            phone: 'Telefon'
        },
        collection: {
            title: 'Datenerhebung',
            intro: 'Wir erheben Informationen, die Sie uns direkt über unser Kontaktformular mitteilen, sowie begrenzte Daten, die lokal in Ihrem Browser gespeichert werden.',
            personal: {
                title: 'Persönliche Informationen, die Sie bereitstellen',
                name: 'Name (über Kontaktformular)',
                email: 'E-Mail-Adresse (über Kontaktformular)',
                subject: 'Betreff und Dienstleistungsart (über Kontaktformular)',
                message: 'Nachrichten und Anfragen (über Kontaktformular)'
            },
            automatic: {
                title: 'Lokal gespeicherte Daten',
                locale: 'Spracheinstellung (im localStorage Ihres Browsers gespeichert)',
                consent: 'Cookie-Zustimmungspräferenz (im localStorage Ihres Browsers gespeichert)',
                recaptcha: 'Google reCAPTCHA v3 wird im Kontaktformular zum Schutz vor Spam eingesetzt. Dabei können Ihre IP-Adresse und Browserdaten an Google übermittelt werden. Weitere Informationen finden Sie in der Datenschutzerklärung von Google.'
            }
        },
        purpose: {
            title: 'Zweck der Datenverarbeitung',
            intro: 'Wir verwenden Ihre persönlichen Daten für folgende Zwecke:',
            communication: 'Um mit Ihnen zu kommunizieren und auf Ihre über das Kontaktformular eingereichten Anfragen zu antworten',
            services: 'Um unsere IT-Dienstleistungen und Support zu erbringen',
            website: 'Um Ihre Spracheinstellung für eine bessere Benutzererfahrung zu speichern',
            legal: 'Um gesetzlichen Verpflichtungen nachzukommen',
            spam: 'Um unser Kontaktformular vor Spam und Missbrauch zu schützen (über Google reCAPTCHA)'
        },
        legalBasis: {
            title: 'Rechtsgrundlage für die Verarbeitung',
            intro: 'Wir verarbeiten Ihre persönlichen Daten auf Grundlage der folgenden rechtlichen Grundlagen:',
            consent: {
                title: 'Einwilligung',
                content: 'Wenn Sie ausdrücklich der Verarbeitung Ihrer persönlichen Daten für bestimmte Zwecke zustimmen.'
            },
            contract: {
                title: 'Vertragserfüllung',
                content: 'Wenn die Verarbeitung zur Erfüllung unserer vertraglichen Verpflichtungen Ihnen gegenüber erforderlich ist.'
            },
            legitimate: {
                title: 'Berechtigtes Interesse',
                content: 'Wenn die Verarbeitung für unsere berechtigten Geschäftsinteressen erforderlich ist, vorausgesetzt, diese überschreiten nicht Ihre Grundrechte.'
            }
        },
        retention: {
            title: 'Datenspeicherung',
            intro: 'Wir speichern Ihre persönlichen Daten nur so lange, wie es zur Erfüllung der in dieser Richtlinie dargelegten Zwecke erforderlich ist:',
            contact: 'Kontaktformular-Einreichungen: So lange aufbewahrt, wie zur Beantwortung Ihrer Anfrage erforderlich',
            localStorage: 'Browser-localStorage-Daten (Spracheinstellung, Cookie-Zustimmung): Lokal in Ihrem Browser gespeichert, bis Sie Ihre Browserdaten löschen',
            legal: 'Gesetzliche Anforderungen: Wie gesetzlich vorgeschrieben'
        },
        rights: {
            title: 'Ihre Rechte',
            intro: 'Gemäß der DSGVO haben Sie folgende Rechte bezüglich Ihrer persönlichen Daten:',
            access: {
                title: 'Recht auf Auskunft',
                content: 'Sie können eine Kopie der persönlichen Daten anfordern, die wir über Sie speichern.'
            },
            rectification: {
                title: 'Recht auf Berichtigung',
                content: 'Sie können die Berichtigung ungenauer oder unvollständiger persönlicher Daten beantragen.'
            },
            erasure: {
                title: 'Recht auf Löschung',
                content: 'Sie können die Löschung Ihrer persönlichen Daten unter bestimmten Umständen beantragen.'
            },
            portability: {
                title: 'Recht auf Datenübertragbarkeit',
                content: 'Sie können die Übertragung Ihrer persönlichen Daten an einen anderen Diensteanbieter beantragen.'
            }
        },
        contact: {
            title: 'Kontaktinformationen',
            intro: 'Wenn Sie Fragen zu dieser Datenschutzerklärung haben oder Ihre Rechte ausüben möchten, kontaktieren Sie uns bitte:',
            email: 'E-Mail',
            phone: 'Telefon',
            address: 'Adresse'
        },
        changes: {
            title: 'Änderungen dieser Datenschutzerklärung',
            content: 'Diese Datenschutzerklärung kann regelmäßig aktualisiert werden, um Änderungen unserer Praktiken oder gesetzlicher Anforderungen widerzuspiegeln. Alle Aktualisierungen werden auf dieser Seite veröffentlicht. Bitte überprüfen Sie diese Seite regelmäßig, um informiert zu bleiben.'
        }
    },
    // Terms & Conditions
    terms: {
        title: 'Allgemeine Geschäftsbedingungen',
        subtitle: 'Nutzungsbedingungen und Geschäftsbedingungen',
        lastUpdated: 'Zuletzt aktualisiert',
        seo: {
            title: 'AGB - Heidelbell | Geschäftsbedingungen',
            description: 'Lesen Sie Heidelbells Allgemeine Geschäftsbedingungen für IT-Dienstleistungen, einschließlich unserer 3Es-Methode und Serviceverpflichtungen.'
        },
        introduction: {
            title: 'Einleitung',
            content: 'Diese Allgemeinen Geschäftsbedingungen regeln die Nutzung der Dienstleistungen und der Website von Heidelbell. Durch die Nutzung unserer Dienstleistungen stimmen Sie diesen Bedingungen zu.',
            acceptance: 'Ihre fortgesetzte Nutzung unserer Dienstleistungen stellt die Annahme dieser Bedingungen dar.'
        },
        company: {
            title: 'Firmeninformationen',
            name: 'Firmenname',
            address: 'Adresse',
            email: 'E-Mail',
            phone: 'Telefon'
        },
        services: {
            title: 'Dienstleistungen',
            intro: 'Heidelbell bietet umfassende IT-Beratung und Dienstleistungen mit unserer bewährten 3Es-Methode (Evaluate, Execute, Elevate).',
            offered: {
                title: 'Angebotene Dienstleistungen',
                infrastructure: 'Infrastruktur-Installation & Wartung',
                helpdesk: 'Help Desk Support',
                project: 'Projektmanagement Support',
                development: 'Software-Entwicklung & Testing',
                optimization: 'Prozessoptimierung',
                data: 'Datenmanagement'
            },
            quality: {
                title: 'Servicequalität',
                content: 'Wir sind verpflichtet, hochwertige Dienstleistungen zu erbringen, die Industriestandards erfüllen und die Erwartungen der Kunden übertreffen.'
            }
        },
        client: {
            title: 'Kundenverpflichtungen',
            intro: 'Als Kunde stimmen Sie zu:',
            cooperation: 'Notwendige Zusammenarbeit und Zugang zu Systemen bereitzustellen',
            information: 'Genaue und vollständige Informationen zu liefern',
            access: 'Angemessenen Zugang zu Ihren Räumlichkeiten und Systemen zu gewähren',
            payment: 'Rechnungen gemäß den Zahlungsbedingungen zu bezahlen',
            confidentiality: 'Die Vertraulichkeit unserer proprietären Informationen zu wahren'
        },
        payment: {
            title: 'Zahlungsbedingungen',
            invoicing: {
                title: 'Rechnungsstellung',
                content: 'Rechnungen werden monatlich oder bei Abschluss der Dienstleistungen ausgestellt, wie in einzelnen Servicevereinbarungen vereinbart.'
            },
            terms: {
                title: 'Zahlungsbedingungen',
                content: 'Die Zahlung ist innerhalb von 30 Tagen nach Rechnungsdatum fällig, sofern in der Servicevereinbarung nichts anderes vereinbart ist.'
            },
            late: {
                title: 'Verspätete Zahlung',
                content: 'Verspätete Zahlungen können zur Aussetzung der Dienstleistungen und zu zusätzlichen Gebühren führen, wie gesetzlich zulässig.'
            }
        },
        intellectual: {
            title: 'Geistiges Eigentum',
            heidelbell: {
                title: 'Heidelbell IP',
                content: 'Alle von Heidelbell entwickelten geistigen Eigentumsrechte bleiben unser Eigentum, es sei denn, sie werden ausdrücklich schriftlich übertragen.'
            },
            client: {
                title: 'Kunden-IP',
                content: 'Das geistige Eigentum des Kunden bleibt Eigentum des Kunden. Wir respektieren und schützen die IP-Rechte der Kunden.'
            },
            third: {
                title: 'Drittanbieter-IP',
                content: 'Wir stellen ordnungsgemäße Lizenzierung und Compliance mit geistigem Eigentum von Drittanbietern sicher, das in unseren Dienstleistungen verwendet wird.'
            }
        },
        confidentiality: {
            title: 'Vertraulichkeit',
            intro: 'Beide Parteien stimmen zu, die strikte Vertraulichkeit von proprietären und sensiblen Informationen zu wahren.',
            obligation: {
                title: 'Vertraulichkeitsverpflichtung',
                content: 'Alle während unseres Engagements geteilten Informationen werden als vertraulich behandelt und entsprechend geschützt.'
            },
            exceptions: {
                title: 'Ausnahmen',
                public: 'Öffentlich verfügbare Informationen',
                legal: 'Gesetzlich oder gerichtlich erforderliche Informationen',
                consent: 'Mit schriftlicher Zustimmung offengelegte Informationen'
            }
        },
        liability: {
            title: 'Haftung',
            limitation: {
                title: 'Haftungsbeschränkung',
                content: 'Unsere Haftung ist auf den Betrag beschränkt, der für die spezifische Dienstleistung bezahlt wurde, die den Anspruch verursacht hat.'
            },
            exclusions: {
                title: 'Ausgeschlossene Schäden',
                indirect: 'Indirekte oder Folgeschäden',
                consequential: 'Gewinnverluste oder Geschäftsunterbrechungen',
                third: 'Drittanbieteransprüche'
            },
            maximum: {
                title: 'Maximale Haftung',
                content: 'Unsere Gesamthaftung darf den Gesamtbetrag nicht überschreiten, den der Kunde in den 12 Monaten vor dem Anspruch bezahlt hat.'
            }
        },
        termination: {
            title: 'Kündigung',
            notice: {
                title: 'Kündigungsfrist',
                content: 'Jede Partei kann die Dienstleistungen mit 30 Tagen schriftlicher Kündigung beenden, sofern in der Servicevereinbarung nichts anderes vereinbart ist.'
            },
            immediate: {
                title: 'Sofortige Kündigung',
                breach: 'Wesentliche Verletzung dieser Bedingungen',
                insolvency: 'Insolvenz oder Konkurs',
                force: 'Höhere Gewalt'
            },
            effects: {
                title: 'Auswirkungen der Kündigung',
                content: 'Bei Kündigung werden wir laufende Arbeiten abschließen und Kundeneigentum zurückgeben. Die Zahlung für abgeschlossene Dienstleistungen bleibt fällig.'
            }
        },
        forceMajeure: {
            title: 'Höhere Gewalt',
            content: 'Keine Partei haftet für Verzögerungen oder Ausfälle aufgrund von Umständen außerhalb der vernünftigen Kontrolle, einschließlich Naturkatastrophen, staatlichen Maßnahmen oder technischen Ausfällen.'
        },
        governing: {
            title: 'Geltendes Recht',
            content: 'Diese Bedingungen unterliegen deutschem Recht. Alle Streitigkeiten werden vor den Gerichten in Heidelberg, Deutschland, gelöst.'
        },
        disputes: {
            title: 'Streitbeilegung',
            content: 'Wir ermutigen zur gütlichen Beilegung von Streitigkeiten. Bei Bedarf werden Streitigkeiten durch Mediation oder Gerichtsverfahren in Heidelberg, Deutschland, gelöst.'
        },
        severability: {
            title: 'Trennbarkeit',
            content: 'Wenn eine Bestimmung dieser Bedingungen als nicht durchsetzbar erachtet wird, bleiben die verbleibenden Bestimmungen in voller Kraft und Wirkung.'
        },
        contact: {
            title: 'Kontaktinformationen',
            intro: 'Für Fragen zu diesen Bedingungen kontaktieren Sie uns bitte:',
            email: 'E-Mail',
            phone: 'Telefon',
            address: 'Adresse'
        }
    },
    // Impressum
    imprint: {
        title: 'Impressum',
        subtitle: 'Rechtliche Informationen und Firmendetails. Angaben gemäß § 5 TMG',
        lastUpdated: 'Zuletzt aktualisiert',
        seo: {
            title: 'Impressum - Heidelbell | Rechtliche Informationen',
            description: 'Rechtliche Informationen und Firmendetails für Heidelbell, einschließlich Kontaktinformationen und gesetzliche Vertreter.'
        },
        provider: {
            title: 'Diensteanbieter-Informationen',
            name: 'Firmenname',
            address: 'Straße und Hausnummer',
            city: 'Stadt und Postleitzahl',
            country: 'Land'
        },
        contact: {
            title: 'Kontaktinformationen',
            email: 'E-Mail',
            phone: 'Telefon',
            website: 'Website'
        },
        representatives: {
            title: 'Gesetzliche Vertreter',
            content: 'Vertretungsberechtigter Geschäftsführer: Herr Dr. Naved Chaudhri'
        },
        register: {
            title: 'Handelsregister',
            court: 'Registergericht',
            courtValue: 'Amtsgericht Mannheim',
            number: 'Registernummer',
            numberValue: 'HRB 747244'
        },
        vat: {
            title: 'Umsatzsteuer-Informationen',
            content: 'Umsatzsteuer-Identifikationsnummer gemäß § 27 UStG: DE359108048'
        },
        professional: {
            title: 'Berufsverbände',
            content: 'Heidelbell ist Mitglied in relevanten Berufsverbänden und befolgt Industriestandards und bewährte Praktiken.'
        },
        responsibility: {
            title: 'Inhaltliche Verantwortung',
            content: 'Der Inhalt dieser Website wird sorgfältig gepflegt und aktualisiert. Wir können jedoch nicht die Genauigkeit, Vollständigkeit oder Aktualität aller Informationen garantieren.'
        },
        copyright: {
            title: 'Urheberrecht',
            content: 'Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.'
        },
        links: {
            title: 'Externe Links',
            content: 'Diese Website kann Links zu externen Websites enthalten. Wir sind nicht für den Inhalt externer Websites verantwortlich und lehnen jegliche Haftung für deren Inhalt ab.'
        },
        disclaimer: {
            title: 'Haftungsausschluss',
            contentLiability: {
                title: 'Haftung für Inhalte',
                content: 'Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.'
            },
            linkLiability: {
                title: 'Haftung für Links',
                content: 'Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.'
            }
        },
        dataProtection: {
            title: 'Datenschutz',
            content: 'Die Nutzung unserer Webseite ist in der Regel ohne Angabe personenbezogener Daten möglich. Soweit auf unseren Seiten personenbezogene Daten (beispielsweise Name, Anschrift oder eMail-Adressen) erhoben werden, erfolgt dies, soweit möglich, stets auf freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche Zustimmung nicht an Dritte weitergegeben. Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich. Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten durch Dritte zur Übersendung von nicht ausdrücklich angeforderter Werbung und Informationsmaterialien wird hiermit ausdrücklich widersprochen. Die Betreiber der Seiten behalten sich ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung von Werbeinformationen, etwa durch Spam-Mails, vor.',
            link: 'Datenschutzerklärung'
        },
        generatorNote: {
            content: 'Impressum unterstützt mit vom Impressum Generator der Kanzlei Hasselbach, Frankfurt.'
        },
        technical: {
            title: 'Technische Informationen',
            hosting: 'Web-Hosting',
            hostingValue: 'Cloud-basierter Hosting-Service',
            framework: 'Frontend-Framework',
            styling: 'CSS-Framework',
            build: 'Build-Tool'
        }
    },
    // Cookie Consent
    cookies: {
        title: 'Cookie-Zustimmung',
        message: 'Wir verwenden Cookies, um Ihr Browsing-Erlebnis zu verbessern, den Website-Traffic zu analysieren und Inhalte zu personalisieren. Durch Klicken auf "Akzeptieren" stimmen Sie der Verwendung von Cookies zu.',
        accept: 'Akzeptieren',
        reject: 'Ablehnen',
        learnMore: 'Erfahren Sie mehr über unsere Cookie-Richtlinie'
    },
    // Attributions & Credits
    attributions: {
        title: 'Bildnachweise & Danksagungen',
        subtitle: 'Bild- und Medienquellen',
        lastUpdated: 'Zuletzt aktualisiert',
        seo: {
            title: 'Bildnachweise & Danksagungen - Heidelbell | Bildquellen',
            description: 'Quellenangaben und Danksagungen für Bilder, Videos und Grafiken, die auf der Heidelbell-Website verwendet werden, einschließlich Freepik-Assets.'
        },
        introduction: {
            title: 'Einführung',
            content: 'Wir glauben daran, den Urhebern, deren Werke unsere Website bereichern, angemessen Anerkennung zu zollen. Diese Seite listet alle auf unserer Website verwendeten Bilder, Videos und Grafiken von Drittanbietern zusammen mit ihren Quellen und Quellenangaben auf.'
        },
        disclaimer: {
            title: 'Allgemeiner Haftungsausschluss',
            content: 'Während wir uns bemühen, die Genauigkeit aller auf dieser Seite aufgeführten Quellenangaben und Danksagungen sicherzustellen, erkennen wir an, dass Fehler auftreten können. Dieser Haftungsausschluss umfasst:',
            typos: 'Tippfehler, Rechtschreibfehler oder Formatierungsfehler in den Quellenangaben',
            accuracy: 'Ungenauigkeiten in URLs, Autorennamen oder anderen Quellenangaben, die bei der Dateneingabe oder Aktualisierung aufgetreten sein können',
            contact: 'Wenn Sie Fehler oder Ungenauigkeiten bemerken, kontaktieren Sie uns bitte, damit wir diese umgehend korrigieren können'
        },
        freepik: {
            title: 'Freepik-Assets',
            intro: 'Einige auf dieser Website verwendete Bilder, Videos und Vektorgrafiken stammen von Freepik.com. Wir sind den Urhebern dankbar, die ihre Arbeit über Freepik zur Verfügung stellen.',
            disclaimer: 'Freepik-Lizenz:',
            license: 'Alle von Freepik verwendeten Assets unterliegen den Lizenzbedingungen von Freepik. Für Premium-Assets haben wir die entsprechenden Lizenzen erworben. Für kostenlose Assets halten wir uns an die Anerkennungsanforderungen von Freepik.',
            by: 'von',
            images: {
                title: 'Bilder von Freepik'
            },
            videos: {
                title: 'Videos von Freepik'
            },
            vectors: {
                title: 'Vektorgrafiken & Symbole von Freepik'
            },
            template: {
                title: 'So fügen Sie Quellenangaben-Links hinzu',
                instruction: 'Um Ihre Freepik-Quellenangaben-Links hinzuzufügen, bearbeiten Sie das freepikAssets-Objekt in src/views/Attributions.vue und fügen Sie Einträge im folgenden Format hinzu:'
            }
        },
        other: {
            title: 'Weitere Quellenangaben',
            intro: 'Zusätzliche Assets und Ressourcen, die auf dieser Website verwendet werden:',
            none: 'Derzeit werden keine anderen Assets von Drittanbietern verwendet.',
            
        },
        contact: {
            title: 'Kontakt',
            intro: 'Wenn Sie Fragen zu Quellenangaben haben oder glauben, dass ein Asset falsch zugeordnet wurde, kontaktieren Sie uns bitte:',
            email: 'E-Mail',
            phone: 'Telefon'
        }
    }
} 